var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderCampaignCoupons',{ref:"header",attrs:{"id":_vm.id,"channels-list":_vm.channelsList},on:{"refresh":_vm.loadCoupons}}),_c('ListCampaignCoupons',{attrs:{"id":_vm.id,"coupons":_vm.coupons,"loading":_vm.loading},on:{"refresh":_vm.loadCoupons,"edit":_vm.openEditDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }